import React from 'react';
import './Badge.css';

/**
 * Badge primitive — small label for product attributes
 * (New, Popular, Sale), order statuses, category names, etc.
 *
 * Variants:
 *  - `neutral` (default) — hairline outline, ink-muted text.
 *                          Category labels, generic chips.
 *  - `brand`             — soft brand-tint background, brand text.
 *                          Use sparingly for "Popular" callouts.
 *  - `success`           — soft success tint. "In stock", "New".
 *  - `warning`           — soft warning tint. "Low stock".
 *  - `danger`            — soft error tint. "Out of stock".
 */
const Badge = React.forwardRef(({
  variant = 'neutral',
  className = '',
  children,
  ...rest
}, ref) => {
  const classes = [
    'badge-primitive',
    `badge-primitive--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <span ref={ref} className={classes} {...rest}>
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;
